'use client';

import { c as _c } from "react/compiler-runtime";
import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { User } from '@/payload-types';
import { checkRole } from '@/payload/authorization/checkRole';
import { useClerk, useUser } from '@clerk/nextjs';
import { rest } from './rest';
export const AuthProvider: React.FC<{
  children: React.ReactNode;
}> = t0 => {
  const $ = _c(21);
  const {
    children
  } = t0;
  const {
    isLoaded: isClerkLoaded,
    user: clerkUser
  } = useUser();
  const {
    signOut
  } = useClerk();
  const [user, setUser] = useState();
  const [loading, setLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isPro, setIsPro] = useState(false);
  let t1;
  if ($[0] !== clerkUser) {
    t1 = () => {
      if (!clerkUser?.primaryEmailAddress?.emailAddress) {
        return null;
      }
      const now = new Date().toISOString();
      return {
        id: -1,
        email: clerkUser.primaryEmailAddress.emailAddress,
        username: clerkUser.username || clerkUser.firstName || null,
        roles: ["user"],
        tokens: 0,
        updatedAt: now,
        createdAt: now,
        clerkUserId: clerkUser.id,
        ssoProvider: "clerk"
      } as User;
    };
    $[0] = clerkUser;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const getFallbackUserFromClerk = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = async user_0 => {
      setUser(user_0);
      if (user_0) {
        setIsAdmin(checkRole(["admin"], user_0));
        setIsPro(checkRole(["admin"], user_0));
        return;
      }
      setIsAdmin(false);
      setIsPro(false);
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const updateUser = t2;
  let t3;
  if ($[3] !== signOut) {
    t3 = async () => {
      updateUser(null);
      try {
        await signOut({
          redirectUrl: "/login"
        });
        return;
      } catch {
        await signOut();
      }
      if (typeof window !== "undefined") {
        window.location.assign("/login");
      }
    };
    $[3] = signOut;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const logout = t3;
  let t4;
  if ($[5] !== clerkUser || $[6] !== getFallbackUserFromClerk || $[7] !== isClerkLoaded) {
    t4 = () => {
      const fetchMe = async () => {
        if (!isClerkLoaded) {
          return;
        }
        if (!clerkUser) {
          updateUser(null);
          setLoading(false);
          return;
        }
        const fallbackUser = getFallbackUserFromClerk();
        if (fallbackUser) {
          updateUser(fallbackUser);
        }
        setLoading(false);
        try {
          const payloadUser = await rest("/api/auth/me", {}, {
            method: "GET"
          });
          if (payloadUser) {
            updateUser(payloadUser);
            return;
          }
          updateUser(fallbackUser);
        } catch {
          updateUser(fallbackUser);
        }
      };
      fetchMe();
    };
    $[5] = clerkUser;
    $[6] = getFallbackUserFromClerk;
    $[7] = isClerkLoaded;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== clerkUser || $[10] !== isClerkLoaded) {
    t5 = [isClerkLoaded, clerkUser];
    $[9] = clerkUser;
    $[10] = isClerkLoaded;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  useEffect(t4, t5);
  let t6;
  if ($[12] !== isAdmin || $[13] !== isPro || $[14] !== loading || $[15] !== logout || $[16] !== user) {
    t6 = {
      isAdmin,
      logout,
      loading,
      setUser,
      user,
      isPro
    };
    $[12] = isAdmin;
    $[13] = isPro;
    $[14] = loading;
    $[15] = logout;
    $[16] = user;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== children || $[19] !== t6) {
    t7 = <Context.Provider value={t6}>{children}</Context.Provider>;
    $[18] = children;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
};
const Context = createContext({} as {
  loading: boolean;
  isAdmin: boolean;
  logout: () => Promise<void>;
  setUser: (user: null | User) => void;
  user?: null | User;
  isPro: boolean;
});
export const useAuth = () => {
  return useContext(Context);
};